import { IRoleTypeService } from "../../service/role/RoleTypeService";

export default class GetRoleTypePositionTypesInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(roleTypeCode: string) {
    return this.roleTypeService.getRoleTypePositionTypes(roleTypeCode);
  }
}
